import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import {AuthService} from "../../data/services/modules/auth/auth.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to api url
    const currentUser = this.authService.getUser;
    const isLoggedIn = currentUser && currentUser.token;
    const isApiUrl = request.url.startsWith(environment.apiUrl) || request.url.startsWith(environment.apiDomiciliation);
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          'authorization':  `Bearer ${currentUser?.token}`,
        },
      });
    }
    return next.handle(request);
  }
}
